import { Experiment } from 'server/shop-config/types'

// eslint-disable-next-line max-params
export function isExperimentVariableTrue(
  key: string,
  variable: string,
  experiments: Experiment[] = []
): boolean {
  const experiment = experiments.find(e => e.name === key)
  if (!experiment?.isEnabled) {
    return false
  }

  return experiment?.variables?.[variable] === true
}
